define('root/app_store/Podio.UI.AppStore.NewEditShare',['require','translate','underscore','jquery','lib/jquery/jquery.elastic','lib/jquery/jquery.podioDropdown','lib/fileuploader/multi','lib/Podio.UI','lib/Podio.Transport','lib/Podio.UI.FlashMessage','lib/Podio.Router','lib/Podio.Event.UI','lib/Podio.FormValidation'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.elastic');
  require('lib/jquery/jquery.podioDropdown');

  var FileUploaderMulti = require('lib/fileuploader/multi');
  var ui = require('lib/Podio.UI');
  var transport = require('lib/Podio.Transport');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var router = require('lib/Podio.Router');
  var podioEventUI = require('lib/Podio.Event.UI');
  var formValidation = require('lib/Podio.FormValidation');

  var uploaderInstances = [];

  function initUploaders(elmForm) {

    _.each(elmForm.find('.files-box'), function(domFileBox) {
      var elmFileBox = $(domFileBox);

      uploaderInstances.push(FileUploaderMulti.render(elmFileBox, {
        skin : 'multi-file form-embed',
        elmUploadWrapper: elmFileBox,
        elmAvatarWrapper: elmFileBox.find('.upload-attachment'),
        elmHiddenInput : elmFileBox.find('.files-hidden-input'),
        useFileFinder: false
      }));
    });
  }

  function onSubmit(elmForm, e) {
    if (elmForm.valid()) {
      var elmButton = elmForm.find('button.submit');
      ui.disableButtonWithLoader(elmButton);

      transport.postJSON(elmForm.attr('action'), { requestData: elmForm.serialize() }, function(responseData) {
        if (responseData.status === 'redirect') {
          // Do nothing, we should already be redirected at this point
        } else {
          if (!responseData.error_propagate) {
            flashMessage.show(t('An unexpected error occured while sharing your app. Please try again. #shares'), 'error');
          }
          ui.restoreButtonWithLoader(elmButton);
        }
      });
    }
  }

  function initForm(elmForm) {
    elmForm.find('textarea').elastic();
    elmForm.find('select').podioDropdown();
  }

  function initCharCounter(elmForm) {
    var elmFields = $('.count-chars');
    _.each(elmFields, function(nodeField) {
      updateCharCounter($(nodeField));
    });
  }

  function updateCharCounter(elmField) {
    var elmNumber = elmField.parent().siblings('.char-counter').find('.number');
    elmNumber.text(100 - elmField.val().length);
  }

  function onNewEditRouteInvoked(routeData) {

    var elmForm = $('.share-form');
    initUploaders(elmForm);

    formValidation.init(elmForm);

    initForm(elmForm);
    initCharCounter(elmForm);
  }

  router.addRoute('{org_slug}/{space_slug}/apps/{app_name}/shares/new', onNewEditRouteInvoked, { waitUntilDomReady: true });
  router.addRoute('{org_slug}/{space_slug}/apps/{app_name}/shares/{share_id}/edit', onNewEditRouteInvoked, { waitUntilDomReady: true });
  router.addRoute('{org_slug}/{space_slug}/shares/new', onNewEditRouteInvoked, { waitUntilDomReady: true });
  router.addRoute('{org_slug}/{space_slug}/shares/{share_id}/edit', onNewEditRouteInvoked, { waitUntilDomReady: true });
  podioEventUI.bind('submit', '.share-form', onSubmit);
  podioEventUI.bind('keyup', '.count-chars', updateCharCounter);

});

